import React from "react";
import { Check } from "lucide-react";

interface SurveyCardProps {
  text: string;
  selected: boolean;
  onClick: () => void;
  icon?: string;
  dimmed?: boolean;
}

export default function SurveyCard({ text, selected, onClick, icon: _icon, dimmed }: SurveyCardProps) {
  return (
    <button
      onClick={onClick}
      className={`w-full text-left p-5 rounded-2xl border-2 transition-all duration-200 flex items-start gap-4 ${
        selected
          ? "border-pista-700 bg-pista-50 shadow-md"
          : dimmed
            ? "border-gray-200 bg-gray-100 opacity-50"
            : "border-gray-200 bg-white hover:border-pista-500 hover:shadow-sm"
      }`}
      type="button"
    >
      {selected && (
        <div className="mt-1 w-5 h-5 rounded-full bg-pista-700 flex items-center justify-center flex-shrink-0">
          <Check className="w-3 h-3 text-white" strokeWidth={3} />
        </div>
      )}
      {!selected && (
        <div className="mt-1 w-5 h-5 rounded-full border-2 border-gray-300 flex-shrink-0" />
      )}
      <span className="text-base md:text-lg leading-relaxed text-gray-800">{text}</span>
    </button>
  );
}
